var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGeofence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.66 85.33",
    style: {
      enableBackground: "new 0 0 87.66 85.33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.21,27.41c0.5,0.08,0.99,0.16,1.49,0.23c4.8,0.67,8.92,2.74,12.34,6.15c2.89,2.88,4.78,6.35,5.73,10.32 c0.95,3.99,0.64,7.91-0.6,11.79c-1.22,3.84-3.04,7.4-5.15,10.82c-3.9,6.33-8.55,12.06-13.7,17.41c-1.11,1.15-2.06,1.15-3.16,0 c-5.85-6.11-11.12-12.67-15.25-20.08c-2.07-3.71-3.75-7.57-4.48-11.8c-0.53-3.09-0.31-6.12,0.54-9.12 c1.3-4.53,3.81-8.26,7.53-11.16c3.37-2.62,7.19-4.1,11.44-4.48c0.11-0.01,0.21-0.06,0.32-0.09C64.26,27.41,65.24,27.41,66.21,27.41 z M75.54,48.99c-0.01-5.94-4.88-10.8-10.82-10.79c-5.92,0.02-10.76,4.85-10.77,10.77c-0.02,5.93,4.85,10.81,10.79,10.81 C70.68,59.8,75.55,54.93,75.54,48.99z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.05,2.2c0.5,0.08,0.99,0.16,1.49,0.23c4.8,0.67,8.92,2.74,12.34,6.15c2.89,2.88,4.78,6.35,5.73,10.32 c0.95,3.99,0.64,7.91-0.6,11.79c-1.22,3.84-3.04,7.4-5.15,10.82c-3.9,6.33-8.55,12.06-13.7,17.41c-1.11,1.15-2.06,1.15-3.16,0 C14.16,52.82,8.89,46.26,4.76,38.85c-2.07-3.71-3.75-7.57-4.48-11.8c-0.53-3.09-0.31-6.12,0.54-9.12c1.3-4.53,3.81-8.26,7.53-11.16 c3.37-2.62,7.19-4.1,11.44-4.48c0.11-0.01,0.21-0.06,0.32-0.09C21.1,2.2,22.07,2.2,23.05,2.2z M32.38,23.79 C32.37,17.85,27.5,12.98,21.57,13c-5.92,0.02-10.76,4.85-10.77,10.77c-0.02,5.93,4.85,10.81,10.79,10.81 C27.52,34.59,32.39,29.72,32.38,23.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeofence);
export default __webpack_public_path__ + "static/media/icon_geofence.387d023b12c0f1ec61e8707ac5e06c9d.svg";
export { ForwardRef as ReactComponent };